import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create(
{
    page: {
        flex: 1,
        marginTop: 32,
    },

    title: {
        fontSize: 36,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '700'
    },

    text: {
        fontSize: 16,
        color: '#535353',
        fontFamily: 'Montserrat',
        fontWeight: '400',
        marginTop: 64
    },

    map: {
        marginTop: 32,
        height: 496,
    },

    line: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20
    },

    image: {
        resizeMode: 'cover',
        marginRight: 16,
    }
});